/* eslint-disable */
import React from 'react';
import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';

type Props = { children: string | React.ReactNode };
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: '#a2a2a2',
      textAlign: 'left',
      width: '100%',
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      display: 'block',
    },
  }));

export function ComponentFootnote(props: Props) {
  const classes = useStyles(props);
  const { children } = props;
  return (
    <Typography variant="caption" classes={classes}>
      {children}
    </Typography>
  );
}